const isNonEmptyString = (str: string) => {
    return typeof str === 'string' && str.length > 0;
};

const isMinusString = (str: string) => {
    return typeof str === 'string' && str === '-';
};

export function capitalizeFirst(str: string) {
    if (!isNonEmptyString(str) || isMinusString(str)) return str;

    let head = str[0].toUpperCase();
    let tail = str.substr(1);
    return '' + head + tail;
}

export function capitalize(str: string) {
    if (!isNonEmptyString(str) || isMinusString(str)) return str;

    let words = str
        .split(/(\s+|-)/)
        .map(w => w.toLocaleLowerCase())
        .map(capitalizeFirst)
        .filter(s => s.length > 0);

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i].replace(/\s+/, ' ');
    }

    return words.join('');
}

export default {
    capitalizeFirst,
    capitalize
};
